// Gabarits PDF proposés pour un DEVIS — à partir de la liste servie par
// GET /api/metier/devis-template/templates.
//
// 🔴 Z23 — un tenant peut porter plusieurs gabarits marqués `is_default`, plus un
// gabarit FACTURE. L'écran prenait « le premier `is_default` » et l'envoyait au
// serveur : « Télécharger » ne sortait pas le même PDF que le rendu par défaut.
// ⇒ Le serveur DIT lequel il rendra (`defaut_rendu`) et le type de chaque
//    gabarit (`type_document`) ; l'écran ne devine plus.

/** Les gabarits qu'on peut proposer pour un devis : jamais un gabarit facture. */
export function gabaritsDevisSelectionnables(templates) {
  return (templates || []).filter((t) => t && t.type_document !== "facture");
}

/**
 * Le gabarit que le serveur rend par défaut pour un devis.
 * Repli sur `is_default` seulement si le serveur ne renseigne pas `defaut_rendu`
 * (ancienne réponse) — jamais sur un gabarit facture.
 */
export function gabaritDevisParDefaut(templates) {
  const candidats = gabaritsDevisSelectionnables(templates);
  const declare = candidats.find((t) => t.defaut_rendu === true);
  if (declare) return declare;
  const connait = candidats.some((t) => typeof t.defaut_rendu === "boolean");
  return connait ? null : (candidats.find((t) => t.is_default) || null);
}
